import { render, staticRenderFns } from "./LandingMenu.vue?vue&type=template&id=6f98daa5&"
import script from "./LandingMenu.vue?vue&type=script&lang=js&"
export * from "./LandingMenu.vue?vue&type=script&lang=js&"
import style0 from "./LandingMenu.vue?vue&type=style&index=0&id=6f98daa5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports